var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsNumber, IsOptional, ValidateIf, ValidateNested, } from 'class-validator';
/** Raw offered settings: null is unset; zero is an explicit price.
 * Explicit Number types retain numeric-string coercion lost with union metadata.
 * class-transformer preserves null and undefined before converting numbers.
 */
export class OfferedFeeDetailDto {
}
__decorate([
    ValidateIf((_, value) => value !== null),
    Type(() => Number),
    IsNumber(),
    __metadata("design:type", Object)
], OfferedFeeDetailDto.prototype, "discountRate", void 0);
__decorate([
    ValidateIf((_, value) => value !== null),
    Type(() => Number),
    IsNumber(),
    __metadata("design:type", Object)
], OfferedFeeDetailDto.prototype, "hour6", void 0);
__decorate([
    ValidateIf((_, value) => value !== null),
    Type(() => Number),
    IsNumber(),
    __metadata("design:type", Object)
], OfferedFeeDetailDto.prototype, "hour12", void 0);
__decorate([
    ValidateIf((_, value) => value !== null),
    Type(() => Number),
    IsNumber(),
    __metadata("design:type", Object)
], OfferedFeeDetailDto.prototype, "hour24", void 0);
__decorate([
    ValidateIf((_, value) => value !== null),
    Type(() => Number),
    IsNumber(),
    __metadata("design:type", Object)
], OfferedFeeDetailDto.prototype, "excess", void 0);
export class OfferedDayFeeDto {
}
__decorate([
    ValidateNested(),
    Type(() => OfferedFeeDetailDto),
    __metadata("design:type", OfferedFeeDetailDto)
], OfferedDayFeeDto.prototype, "weekday", void 0);
__decorate([
    ValidateNested(),
    Type(() => OfferedFeeDetailDto),
    __metadata("design:type", OfferedFeeDetailDto)
], OfferedDayFeeDto.prototype, "weekend", void 0);
export class UpdateOfferedFeeDetailDto {
}
__decorate([
    IsOptional(),
    Type(() => Number),
    IsNumber(),
    __metadata("design:type", Object)
], UpdateOfferedFeeDetailDto.prototype, "discountRate", void 0);
__decorate([
    IsOptional(),
    Type(() => Number),
    IsNumber(),
    __metadata("design:type", Object)
], UpdateOfferedFeeDetailDto.prototype, "hour6", void 0);
__decorate([
    IsOptional(),
    Type(() => Number),
    IsNumber(),
    __metadata("design:type", Object)
], UpdateOfferedFeeDetailDto.prototype, "hour12", void 0);
__decorate([
    IsOptional(),
    Type(() => Number),
    IsNumber(),
    __metadata("design:type", Object)
], UpdateOfferedFeeDetailDto.prototype, "hour24", void 0);
__decorate([
    IsOptional(),
    Type(() => Number),
    IsNumber(),
    __metadata("design:type", Object)
], UpdateOfferedFeeDetailDto.prototype, "excess", void 0);
export class UpdateOfferedDayFeeDto {
}
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => UpdateOfferedFeeDetailDto),
    __metadata("design:type", UpdateOfferedFeeDetailDto)
], UpdateOfferedDayFeeDto.prototype, "weekday", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => UpdateOfferedFeeDetailDto),
    __metadata("design:type", UpdateOfferedFeeDetailDto)
], UpdateOfferedDayFeeDto.prototype, "weekend", void 0);
export const createUnsetOfferedDayFee = () => {
    const detail = () => ({
        discountRate: null,
        hour6: null,
        hour12: null,
        hour24: null,
        excess: null,
    });
    return { weekday: detail(), weekend: detail() };
};
